var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 171.68C139.588 171.68 171.68 139.588 171.68 100C171.68 60.4122 139.588 28.32 100 28.32C60.4122 28.32 28.32 60.4122 28.32 100C28.32 139.588 60.4122 171.68 100 171.68Z",
    fill: "#ECEEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.667 53.3604H45.0402C39.6904 53.3604 35.3535 57.6972 35.3535 63.047V142C35.3535 147.35 39.6904 151.687 45.0402 151.687H159.667C165.017 151.687 169.354 147.35 169.354 142V63.047C169.354 57.6972 165.017 53.3604 159.667 53.3604Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 60.627H165V135.807C165 142.167 159.84 147.327 153.48 147.327H40.76C35.3733 147.327 31 142.954 31 137.567V60.627Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3133 49H156.767C161.313 49 165 52.6867 165 57.2333V60.6267H31V59.3133C31 53.62 35.62 49 41.3133 49Z",
    fill: "#36A635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.313 49H40.6867C35.3369 49 31 53.3369 31 58.6867V137.64C31 142.99 35.3369 147.327 40.6867 147.327H155.313C160.663 147.327 165 142.99 165 137.64V58.6867C165 53.3369 160.663 49 155.313 49Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 60.627H165",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.66 57.1871C40.9707 57.1871 42.0333 56.1245 42.0333 54.8138C42.0333 53.503 40.9707 52.4404 39.66 52.4404C38.3492 52.4404 37.2866 53.503 37.2866 54.8138C37.2866 56.1245 38.3492 57.1871 39.66 57.1871Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0535 57.1871C49.3643 57.1871 50.4268 56.1245 50.4268 54.8138C50.4268 53.503 49.3643 52.4404 48.0535 52.4404C46.7428 52.4404 45.6802 53.503 45.6802 54.8138C45.6802 56.1245 46.7428 57.1871 48.0535 57.1871Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4534 57.1871C57.7642 57.1871 58.8267 56.1245 58.8267 54.8138C58.8267 53.503 57.7642 52.4404 56.4534 52.4404C55.1427 52.4404 54.0801 53.503 54.0801 54.8138C54.0801 56.1245 55.1427 57.1871 56.4534 57.1871Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.46 133.026C43.46 127.84 43.4333 122.92 51.5933 120.953C53.4133 120.513 55.6466 119.873 57.74 119.02L58.3466 119.1C61.7333 123.026 66.6466 125.453 71.8666 125.453C77.0866 125.453 81.9866 123.033 85.3866 119.1L85.4733 118.8C87.7066 119.766 90.1733 120.473 92.14 120.953C100.3 122.92 100.273 127.84 100.273 133.026H43.46Z",
    fill: "#36A635"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4736 118.794L85.3869 119.094C81.9869 123.02 77.0802 125.447 71.8669 125.447C66.6536 125.447 61.7336 123.027 58.3469 119.094L57.7402 119.014C61.2202 117.58 64.2869 115.534 64.2869 112.747V108.86C64.8469 109.407 65.4736 109.887 66.1802 110.294C67.6669 111.154 68.1936 112.187 71.8669 112.187C75.5402 112.187 76.0602 111.154 77.5469 110.294C78.2536 109.887 78.8869 109.4 79.4402 108.854V112.747C79.4402 115.394 82.2069 117.374 85.4736 118.794Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.447 108.861C78.887 109.407 78.2603 109.887 77.5537 110.301C76.067 111.161 75.5403 112.194 71.8737 112.194C68.207 112.194 67.6803 111.161 66.187 110.301C65.4803 109.894 64.8537 109.407 64.2937 108.867C62.3203 106.947 61.227 104.281 60.687 101.567C60.687 101.567 57.667 101.307 57.667 97.0473C57.667 95.6207 58.067 94.8473 58.347 94.4807C58.4937 94.2807 58.607 94.2073 58.607 94.2073C61.3003 92.9673 63.3403 90.2607 65.2337 85.6807C69.1137 89.3607 74.9403 87.3273 76.947 87.3273C82.567 87.3273 82.1203 94.2007 85.1203 94.2007C85.1203 94.2007 85.2337 94.2807 85.387 94.474C85.667 94.8407 86.067 95.614 86.067 97.0407C86.067 101.301 83.047 101.561 83.047 101.561C82.5003 104.267 81.4137 106.941 79.4337 108.854L79.447 108.861Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0733 88.6939C86.0733 90.5272 86.0733 92.6605 85.3933 94.4739C85.2467 94.2739 85.1267 94.2005 85.1267 94.2005C82.1267 94.2005 82.5733 87.3272 76.9533 87.3272C74.94 87.3272 69.12 89.3605 65.24 85.6805C63.3467 90.2605 61.3067 92.9672 58.6133 94.2072C58.6133 94.2072 58.5 94.2872 58.3533 94.4805C57.6733 92.6739 57.6733 92.2005 57.6733 87.5739C57.6733 83.8472 60.04 80.9472 62.4067 80.0005C63.8867 77.8139 66.1333 76.2139 71.88 76.2139C74.2133 76.2139 76.46 76.6339 78.4533 77.4939H78.4733C82 78.4739 85.14 78.1072 85.14 78.1072C85.14 78.1072 85.5867 80.2405 84.1933 81.8939C85.5 83.6072 86.0933 86.5405 86.0933 88.7005L86.0733 88.6939Z",
    fill: "#4D4D4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1268 94.2002C85.1268 94.2002 85.2402 94.2802 85.3935 94.4735C85.6735 94.8402 86.0735 95.6135 86.0735 97.0402C86.0735 101.3 83.0535 101.56 83.0535 101.56C82.5068 104.267 81.4202 106.94 79.4402 108.854C78.8802 109.4 78.2535 109.88 77.5468 110.294C76.0602 111.154 75.5335 112.187 71.8668 112.187C68.2002 112.187 67.6735 111.154 66.1802 110.294C65.4735 109.887 64.8468 109.4 64.2868 108.86C62.3135 106.94 61.2202 104.274 60.6802 101.56C60.6802 101.56 57.6602 101.3 57.6602 97.0402C57.6602 95.6135 58.0602 94.8402 58.3402 94.4735C58.4868 94.2735 58.6002 94.2002 58.6002 94.2002",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6133 94.2005C61.3066 92.9605 63.3466 90.2538 65.2399 85.6738C69.1199 89.3538 74.9466 87.3205 76.9533 87.3205C82.5733 87.3205 82.1266 94.1938 85.1266 94.1938",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2935 108.854V112.747C64.2935 115.534 61.2268 117.58 57.7468 119.014C55.6535 119.874 53.4201 120.507 51.6001 120.947C43.4335 122.914 43.4668 127.834 43.4668 133.02H100.28C100.28 127.834 100.307 122.914 92.1468 120.947C90.1735 120.467 87.7135 119.76 85.4801 118.794C82.2201 117.374 79.4468 115.394 79.4468 112.747V108.854",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3467 119.094C61.7333 123.02 66.6467 125.447 71.8667 125.447C77.0867 125.447 81.9867 123.027 85.3867 119.094",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3933 94.4737C86.0733 92.667 86.0733 90.5337 86.0733 88.6937C86.0733 86.5337 85.4867 83.6004 84.1733 81.887C85.5667 80.2337 85.12 78.1004 85.12 78.1004C85.12 78.1004 81.98 78.467 78.4533 77.487H78.4333C76.44 76.627 74.1933 76.207 71.86 76.207C66.12 76.207 63.8667 77.807 62.3867 79.9937C60.02 80.9404 57.6533 83.8404 57.6533 87.567C57.6533 92.187 57.6533 92.6604 58.3333 94.4737",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.787 85.6738H145.3",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.187 97.8066H152.9",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.187 106.527H152.9",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.187 115.521H152.9",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0401 69.2998H96.1001C99.4668 69.2998 102.2 72.0331 102.2 75.3998V133.026H42.7935V76.5465C42.7935 72.5465 46.0401 69.2998 50.0401 69.2998Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.52873d175a90000c8cec12e5bd814909.svg";
export { ForwardRef as ReactComponent };